/**
 * Gleem Core - Modulo EB: Router Configuration
 * Routing modulare organizzato per aree funzionali
 */

import { RouteRecordRaw } from 'vue-router'

// Shared Views (lazy loaded)
const Dashboard = () => import('../views/Dashboard/DashboardHome.vue')
const OperationsDashboard = () => import('../views/Dashboard/OperationsDashboard.vue')

// Customers
const CustomerList = () => import('../views/Customers/CustomerList.vue')
const CustomerDetail = () => import('../views/Customers/CustomerDetail.vue')
const CustomerForm = () => import('../views/Customers/CustomerForm.vue')
const ArchivedCustomersList = () => import('../views/Customers/ArchivedCustomersList.vue')

// Boilers
const BoilerList = () => import('../views/Boilers/BoilerList.vue')
const BoilerDetail = () => import('../views/Boilers/BoilerDetail.vue')
const BoilerForm = () => import('../views/Boilers/BoilerForm.vue')

// Interventions
const CalendarView = () => import('../views/Interventions/CalendarView.vue')
const InterventionList = () => import('../views/Interventions/InterventionList.vue')
const InterventionDetail = () => import('../views/Interventions/InterventionDetail.vue')
const InterventionWizard = () => import('../views/Interventions/InterventionWizard.vue')
const InterventionEdit = () => import('../views/Interventions/InterventionEdit.vue')

// Templates
const TemplateList = () => import('../views/Templates/TemplateList.vue')
const TemplateEditor = () => import('../views/Templates/TemplateEditor.vue')

// CRM & Sales

// Call Logs
const CallLogsList = () => import('../views/CallLogs/CallLogsList.vue')

// Tasks
// Tasks
const TaskList = () => import('../views/Tasks/TaskList.vue')
const TaskDetail = () => import('../views/Tasks/TaskDetail.vue')
const TasksDashboard = () => import('../views/Tasks/TasksDashboard.vue')

const SalesList = () => import('../views/Sales/SalesList.vue')
const SalesDetail = () => import('../views/Sales/SalesDetail.vue')

// Boiler manuals

// Catalog
const BoilerModelList = () => import('../views/Catalog/BoilerModelList.vue')
const BoilerModelDetail = () => import('../views/Catalog/BoilerModelDetail.vue')

// Warehouse & Stock
const ProductList = () => import('../views/Warehouse/ProductList.vue')
const ProductDetail = () => import('../views/Warehouse/ProductDetail.vue')
const WarehouseList = () => import('../views/Warehouse/WarehouseList.vue')
const WarehouseDetail = () => import('../views/Warehouse/WarehouseDetail.vue')
const StockPickingList = () => import('../views/Stock/StockPickingList.vue')
const StockValuation = () => import('../views/Stock/StockValuation.vue')

// Accounting
const InvoiceList = () => import('../views/Accounting/InvoiceList.vue')
const IncassiRegistry = () => import('../views/Accounting/IncassiRegistry.vue')
const InvoiceDetail = () => import('../views/Accounting/InvoiceDetail.vue')
const ExpenseList = () => import('../views/Accounting/ExpenseList.vue')
const PaymentList = () => import('../views/Accounting/PaymentList.vue')
const PaymentSchedule = () => import('../views/Accounting/PaymentSchedule.vue')
const BankReconciliation = () => import('../views/Accounting/BankReconciliation.vue')
const JournalEntryList = () => import('../views/Accounting/JournalEntryList.vue')
const PrimaNota = () => import('../views/Accounting/PrimaNota.vue')
const AccountList = () => import('../views/Accounting/AccountList.vue')
const AccountLedger = () => import('../views/Accounting/AccountLedger.vue')
const PartnerStatement = () => import('../views/Accounting/PartnerStatement.vue')
const VatSettlement = () => import('../views/Accounting/VatSettlement.vue')
const CreditNotesList = () => import('../views/Accounting/CreditNotesList.vue')


// Purchases
const SupplierList = () => import('../views/Purchases/SupplierList.vue')
const SupplierForm = () => import('../views/Purchases/SupplierForm.vue')
const SupplierDetail = () => import('../views/Purchases/SupplierDetail.vue')
const PurchaseOrderList = () => import('../views/Purchases/PurchaseOrderList.vue')

const PurchaseOrderDetail = () => import('../views/Purchases/PurchaseOrderDetail.vue')

// Procurement (New)
const PurchaseRequestList = () => import('../views/Procurement/PurchaseRequestList.vue')
const PurchaseRequestDetail = () => import('../views/Procurement/PurchaseRequestDetail.vue')

// Other Functional Areas
const ReportsDashboard = () => import('../views/Reports/Dashboard.vue')
const ExpirationsView = () => import('../views/Expirations/ExpirationsView.vue')
const CertificationList = () => import('../views/Certifications/CertificationList.vue')
const CertificationDetail = () => import('../views/Certifications/CertificationDetail.vue')

// Conto Termico
const ContoTermicoDeadlines = () => import('../views/ContoTermico/DeadlinesView.vue')
const ContoTermicoPracticeList = () => import('../views/ContoTermico/PracticeListView.vue')
const ContoTermicoDashboard = () => import('../views/ContoTermico/DashboardView.vue')

// Employees
const EmployeeList = () => import('../views/Employees/EmployeeList.vue')

// Expenses (Note Spese)
const ExpenseReportList = () => import('../views/Expenses/ExpenseReportList.vue')
const ExpenseReportDetail = () => import('../views/Expenses/ExpenseReportDetail.vue')

// Direct Purchases (Acquisti Diretti)
const DirectPurchaseList = () => import('../views/DirectPurchases/DirectPurchaseList.vue')
const DirectPurchaseDetail = () => import('../views/DirectPurchases/DirectPurchaseDetail.vue')

// GDPR

// Projects (Commesse)

// Cost Centers (Centri di Costo)
const CostCenterList = () => import('../views/CostCenters/CostCenterList.vue')
const CostCenterTree = () => import('../views/CostCenters/CostCenterTree.vue')
const CostCenterDetail = () => import('../views/CostCenters/CostCenterDetail.vue')
const CostCenterDashboard = () => import('../views/CostCenters/CostCenterDashboard.vue')

// Electronic Invoices (Fatture Elettroniche)

// FiC (Fatture in Cloud)
const FiCDashboard = () => import('../views/FiC/FiCDashboard.vue')
const FiCSyncHistory = () => import('../views/FiC/FiCSyncHistory.vue')

// VAT (IVA)
const VatRegisters = () => import('../views/Vat/VatRegisters.vue')
const VatSettlementHistory = () => import('../views/Vat/VatSettlementHistory.vue')

const dashboardRoutes: RouteRecordRaw[] = [
  {
    path: '/eb',
    name: 'EB-Dashboard',
    component: Dashboard,
    meta: { title: 'Dashboard', requiresAuth: true, module: 'eb' }
  },
  {
    path: '/eb/dashboard/operations',
    name: 'EB-OperationsDashboard',
    component: OperationsDashboard,
    meta: { title: 'Cruscotto operativo', requiresAuth: true, module: 'eb' }
  }
]

const customerRoutes: RouteRecordRaw[] = [
  {
    path: '/eb/customers',
    name: 'EB-CustomerList',
    component: CustomerList,
    meta: { title: 'Clienti', requiresAuth: true, module: 'eb' }
  },
  {
    path: '/eb/customers/archived',
    name: 'EB-ArchivedCustomers',
    component: ArchivedCustomersList,
    meta: { title: 'Clienti Archiviati', requiresAuth: true, module: 'eb' }
  },
  {
    path: '/eb/customers/new',
    name: 'EB-CustomerCreate',
    component: CustomerForm,
    meta: { title: 'Nuovo Cliente', requiresAuth: true, module: 'eb' }
  },
  {
    path: '/eb/customers/:id/edit',
    name: 'EB-CustomerEdit',
    component: CustomerForm,
    meta: { title: 'Modifica Cliente', requiresAuth: true, module: 'eb' }
  },
  {
    path: '/eb/customers/:id',
    name: 'EB-CustomerDetail',
    component: CustomerDetail,
    meta: { title: 'Dettaglio Cliente', requiresAuth: true, module: 'eb' }
  }
]

const boilerRoutes: RouteRecordRaw[] = [
  {
    path: '/eb/boilers',
    name: 'EB-BoilerList',
    component: BoilerList,
    meta: { title: 'Impianti', requiresAuth: true, module: 'eb' }
  },
  {
    path: '/eb/boilers/new',
    name: 'EB-BoilerCreate',
    component: BoilerForm,
    meta: { title: 'Nuovo Impianto', requiresAuth: true, module: 'eb' }
  },
  {
    path: '/eb/boilers/:id/edit',
    name: 'EB-BoilerEdit',
    component: BoilerForm,
    meta: { title: 'Modifica Impianto', requiresAuth: true, module: 'eb' }
  },
  {
    path: '/eb/boilers/:id',
    name: 'EB-BoilerDetail',
    component: BoilerDetail,
    meta: { title: 'Dettaglio Impianto', requiresAuth: true, module: 'eb' }
  }
]

const interventionRoutes: RouteRecordRaw[] = [
  {
    path: '/eb/calendar',
    name: 'EB-Calendar',
    component: CalendarView,
    meta: { title: 'Calendario', requiresAuth: true, module: 'eb' }
  },
  {
    path: '/eb/interventions',
    name: 'EB-InterventionList',
    component: InterventionList,
    meta: { title: 'Interventi', requiresAuth: true, module: 'eb' }
  },
  {
    path: '/eb/interventions/new',
    name: 'EB-InterventionCreate',
    component: InterventionWizard,
    meta: { title: 'Nuovo Intervento', requiresAuth: true, module: 'eb' }
  },
  {
    path: '/eb/interventions/:id/edit',
    name: 'EB-InterventionEdit',
    component: InterventionEdit,
    meta: { title: 'Modifica Intervento', requiresAuth: true, module: 'eb' }
  },
  {
    path: '/eb/interventions/calendar',
    name: 'EB-InterventionCalendar',
    component: CalendarView,
    meta: { title: 'Calendario Interventi', requiresAuth: true, module: 'eb' }
  },
  {
    path: '/eb/interventions/:id',
    name: 'EB-InterventionDetail',
    component: InterventionDetail,
    meta: { title: 'Dettaglio Intervento', requiresAuth: true, module: 'eb' }
  }
]

const templateRoutes: RouteRecordRaw[] = [
  {
    path: '/eb/templates',
    name: 'EB-TemplateList',
    component: TemplateList,
    meta: { title: 'Modelli di Stampa', requiresAuth: true, module: 'eb' }
  },
  {
    path: '/eb/templates/:id',
    name: 'EB-TemplateEditor',
    component: TemplateEditor,
    meta: { title: 'Editor Template', requiresAuth: true, module: 'eb' }
  },
  {
    path: '/eb/templates/new',
    name: 'EB-TemplateCreate',
    component: TemplateEditor,
    meta: { title: 'Nuovo Template', requiresAuth: true, module: 'eb' }
  }
]

const crmRoutes: RouteRecordRaw[] = [
]

const callLogRoutes: RouteRecordRaw[] = [
  {
    path: '/eb/call-logs',
    name: 'EB-CallLogsList',
    component: CallLogsList,
    meta: { title: 'Registro Chiamate', requiresAuth: true, module: 'eb' }
  }
]

const taskRoutes: RouteRecordRaw[] = [
  {
    path: '/eb/tasks',
    name: 'EB-TaskList',
    component: TasksDashboard,
    meta: { title: 'Task - Attività', requiresAuth: true, module: 'eb' }
  },

  {
    path: '/eb/tasks/:id',
    name: 'EB-TaskDetail',
    component: TaskDetail,
    meta: { title: 'Dettaglio Task', requiresAuth: true, module: 'eb' }
  }
]

const salesRoutes: RouteRecordRaw[] = [
  {
    path: '/eb/sales',
    name: 'EB-SalesList',
    component: SalesList,
    meta: { title: 'Vendite - Gleem Thermo', requiresAuth: true, module: 'eb' }
  },
  {
    path: '/eb/quotes',
    name: 'EB-QuoteList',
    component: SalesList,
    meta: { title: 'Preventivi - Gleem Thermo', requiresAuth: true, module: 'eb', defaultDocType: 'quote' }
  },
  {
    path: '/eb/orders',
    name: 'EB-OrderList',
    component: SalesList,
    meta: { title: 'Ordini di Vendita - Gleem Thermo', requiresAuth: true, module: 'eb', defaultDocType: 'order' }
  },
  {
    path: '/eb/sales/:id',
    name: 'EB-SalesDetail',
    component: SalesDetail,
    meta: { title: 'Dettaglio Vendita - Gleem Thermo', requiresAuth: true, module: 'eb' }
  }
]

const manualsRoutes: RouteRecordRaw[] = [
]

const catalogRoutes: RouteRecordRaw[] = [
  {
    path: '/eb/catalog/boiler-models',
    name: 'EB-BoilerModelList',
    component: BoilerModelList,
    meta: { title: 'Catalogo Caldaie', requiresAuth: true, module: 'eb' }
  },
  {
    path: '/eb/catalog/boiler-models/:id',
    name: 'EB-BoilerModelDetail',
    component: BoilerModelDetail,
    meta: { title: 'Dettaglio Modello', requiresAuth: true, module: 'eb' }
  }
]

const warehouseRoutes: RouteRecordRaw[] = [
  {
    path: '/eb/warehouses',
    name: 'EB-WarehouseList',
    component: WarehouseList,
    meta: { title: 'Magazzini', requiresAuth: true, module: 'eb' }
  },
  {
    path: '/eb/warehouses/:id',
    name: 'EB-WarehouseDetail',
    component: WarehouseDetail,
    meta: { title: 'Dettaglio Magazzino', requiresAuth: true, module: 'eb' }
  },
  {
    path: '/eb/warehouse/products',
    name: 'EB-ProductList',
    component: ProductList,
    meta: { title: 'Magazzino - Gleem Thermo', requiresAuth: true, module: 'eb' }
  },
  {
    path: '/eb/warehouse/products/:id',
    name: 'EB-ProductDetail',
    component: ProductDetail,
    meta: { title: 'Dettaglio Prodotto - Gleem Thermo', requiresAuth: true, module: 'eb' }
  }
]

const accountingRoutes: RouteRecordRaw[] = [
  {
    path: '/eb/accounting/invoices',
    name: 'EB-InvoiceList',
    component: InvoiceList,
    meta: { title: 'Fatture - Gleem Thermo', requiresAuth: true, module: 'eb' }
  },
  {
    path: '/eb/accounting/invoices/:id',
    name: 'EB-InvoiceDetail',
    component: InvoiceDetail,
    meta: { title: 'Dettaglio Fattura - Gleem Thermo', requiresAuth: true, module: 'eb' }
  },
  {
    path: '/eb/accounting/credit-notes',
    name: 'EB-CreditNotesList',
    component: CreditNotesList,
    meta: { title: 'Note di Credito - Gleem Thermo', requiresAuth: true, module: 'eb' }
  },
  {
    path: '/eb/accounting/incassi',
    name: 'EB-IncassiRegistry',
    component: IncassiRegistry,
    meta: { title: 'Registro Incassi - Gleem Thermo', requiresAuth: true, module: 'eb' }
  },
  {
    path: '/eb/accounting/expenses',
    name: 'EB-ExpenseList',
    component: ExpenseList,
    meta: { title: 'Spese & Uscite', requiresAuth: true, module: 'eb' }
  },
  {
    path: '/eb/accounting/payments',
    name: 'EB-PaymentList',
    component: PaymentList,
    meta: { title: 'Pagamenti - Gleem Thermo', requiresAuth: true, module: 'eb' }
  },
  {
    path: '/eb/accounting/journal',
    name: 'EB-JournalList',
    component: JournalEntryList,
    meta: { title: 'Libro Giornale - Gleem Thermo', requiresAuth: true, module: 'eb' }
  },
  {
    path: '/eb/accounting/primanota',
    name: 'EB-PrimaNota',
    component: PrimaNota,
    meta: { title: 'Prima Nota - Gleem Thermo', requiresAuth: true, module: 'eb' }
  },
  {
    path: '/eb/accounting/accounts',
    name: 'EB-AccountList',
    component: AccountList,
    meta: { title: 'Piano dei Conti - Gleem Thermo', requiresAuth: true, module: 'eb' }
  },
  {
    path: '/eb/accounting/schedule',
    name: 'EB-PaymentSchedule',
    component: PaymentSchedule,
    meta: { title: 'Scadenziario Pagamenti', requiresAuth: true, module: 'eb' }
  },
  {
    path: '/eb/accounting/reconciliation',
    name: 'EB-BankReconciliation',
    component: BankReconciliation,
    meta: { title: 'Riconciliazione Bancaria', requiresAuth: true, module: 'eb' }
  },
  {
    path: '/eb/accounting/ledger',
    name: 'EB-AccountLedgerHome',
    component: AccountLedger,
    meta: { title: 'Partitario', requiresAuth: true, module: 'eb' }
  },
  {
    path: '/eb/accounting/accounts/:id/ledger',
    name: 'EB-AccountLedger',
    component: AccountLedger,
    meta: { title: 'Partitario', requiresAuth: true, module: 'eb' }
  },
  {
    path: '/eb/accounting/partner/:id/statement',
    name: 'EB-PartnerStatement',
    component: PartnerStatement,
    meta: { title: 'Estratto Conto', requiresAuth: true, module: 'eb' }
  },
  {
    path: '/eb/accounting/vat-settlement',
    name: 'EB-VatSettlement',
    component: VatSettlement,
    meta: { title: 'Liquidazione IVA', requiresAuth: true, module: 'eb' }
  },
]

const legacyPurchaseRoutes: RouteRecordRaw[] = [
]

const stockRoutes: RouteRecordRaw[] = [
  {
    path: '/eb/stock',
    name: 'EB-StockPickingList',
    component: StockPickingList,
    meta: { title: 'Magazzino', requiresAuth: true, module: 'eb' }
  },
  {
    path: '/eb/stock/inbound',
    name: 'EB-InboundReceipt',
    component: () => import('../views/Warehouse/InboundReceipt.vue'),
    meta: { title: 'Carico Merce', requiresAuth: true, module: 'eb' }
  },
  {
    path: '/eb/stock/valuation',
    name: 'EB-StockValuation',
    component: StockValuation,
    meta: { title: 'Valutazione Magazzino', requiresAuth: true, module: 'eb' }
  }
]

const reportRoutes: RouteRecordRaw[] = [
  {
    path: '/eb/reports',
    name: 'EB-Reports',
    component: ReportsDashboard,
    meta: { title: 'Report Center', requiresAuth: true, module: 'eb' }
  }
]

const supplierRoutes: RouteRecordRaw[] = [
  {
    path: '/eb/suppliers',
    name: 'EB-SupplierList',
    component: SupplierList,
    meta: { title: 'Fornitori', requiresAuth: true, module: 'eb' }
  },
  {
    path: '/eb/suppliers/new',
    name: 'EB-SupplierCreate',
    component: SupplierForm,
    meta: { title: 'Nuovo Fornitore', requiresAuth: true, module: 'eb' }
  },
  {
    path: '/eb/suppliers/:id',
    name: 'EB-SupplierDetail',
    component: SupplierDetail,
    meta: { title: 'Dettaglio Fornitore', requiresAuth: true, module: 'eb' }
  },
  {
    path: '/eb/suppliers/:id/edit',
    name: 'EB-SupplierEdit',
    component: SupplierForm,
    meta: { title: 'Modifica Fornitore', requiresAuth: true, module: 'eb' }
  }
]

const purchaseRoutes: RouteRecordRaw[] = [
  {
    path: '/eb/purchases',
    name: 'EB-PurchaseOrderList',
    component: PurchaseOrderList,
    meta: { title: 'Ordini di Acquisto', requiresAuth: true, module: 'eb' }
  },
  {
    path: '/eb/purchases/new',
    name: 'EB-PurchaseOrderCreate',
    component: PurchaseOrderDetail,
    meta: { title: 'Nuovo Ordine Acquisto', requiresAuth: true, module: 'eb' }
  },
  {
    path: '/eb/purchases/:id',
    name: 'EB-PurchaseOrderDetail',
    component: PurchaseOrderDetail,
    meta: { title: 'Dettaglio Ordine Acquisto', requiresAuth: true, module: 'eb' }
  }
]

const expirationRoutes: RouteRecordRaw[] = [
  {
    path: '/eb/expirations',
    name: 'EB-Expirations',
    component: ExpirationsView,
    meta: { title: 'Scadenze Manutenzioni', requiresAuth: true, module: 'eb' }
  }
]

const contoTermicoRoutes: RouteRecordRaw[] = [
  {
    path: '/eb/conto-termico/dashboard',
    name: 'EB-ContoTermicoDashboard',
    component: ContoTermicoDashboard,
    meta: { title: 'Dashboard Conto Termico', requiresAuth: true, module: 'eb' }
  },
  {
    path: '/eb/conto-termico/practices',
    name: 'EB-ContoTermicoPractices',
    component: ContoTermicoPracticeList,
    meta: { title: 'Pratiche Conto Termico', requiresAuth: true, module: 'eb' }
  },
  {
    path: '/eb/conto-termico/scadenze',
    name: 'EB-ContoTermicoDeadlines',
    component: ContoTermicoDeadlines,
    meta: { title: 'Scadenze Conto Termico', requiresAuth: true, module: 'eb' }
  }
]

const certificationRoutes: RouteRecordRaw[] = [
  {
    path: '/eb/certifications',
    name: 'EB-Certifications',
    component: CertificationList,
    meta: { title: 'Certificazioni', requiresAuth: true, module: 'eb' }
  },
  {
    path: '/eb/certifications/:id',
    name: 'EB-CertificationDetail',
    component: CertificationDetail,
    meta: { title: 'Dettaglio Certificazione', requiresAuth: true, module: 'eb' }
  }
]

const employeeRoutes: RouteRecordRaw[] = [
  {
    path: '/eb/employees',
    name: 'EB-EmployeeList',
    component: EmployeeList,
    meta: { title: 'Gestione Dipendenti', requiresAuth: true, module: 'eb' }
  }
]

const expenseRoutes: RouteRecordRaw[] = [
  {
    path: '/eb/expenses',
    name: 'EB-ExpenseReportList',
    component: ExpenseReportList,
    meta: { title: 'Note Spese', requiresAuth: true, module: 'eb' }
  },
  {
    path: '/eb/expenses/:id',
    name: 'EB-ExpenseReportDetail',
    component: ExpenseReportDetail,
    meta: { title: 'Dettaglio Nota Spese', requiresAuth: true, module: 'eb' }
  }
]

const directPurchaseRoutes: RouteRecordRaw[] = [
  {
    path: '/eb/direct-purchases',
    name: 'EB-DirectPurchaseList',
    component: DirectPurchaseList,
    meta: { title: 'Acquisti Diretti', requiresAuth: true, module: 'eb' }
  },
  {
    path: '/eb/direct-purchases/:id',
    name: 'EB-DirectPurchaseDetail',
    component: DirectPurchaseDetail,
    meta: { title: 'Dettaglio Acquisto', requiresAuth: true, module: 'eb' }
  }
]

const gdprRoutes: RouteRecordRaw[] = [
]

const procurementRoutes: RouteRecordRaw[] = [
  {
    path: '/eb/procurement/requests',
    name: 'EB-PurchaseRequestList',
    component: PurchaseRequestList,
    meta: { title: 'Richieste di Acquisto', requiresAuth: true, module: 'eb' }
  },
  {
    path: '/eb/procurement/requests/:id',
    name: 'EB-PurchaseRequestDetail',
    component: PurchaseRequestDetail,
    meta: { title: 'Dettaglio RDA', requiresAuth: true, module: 'eb' }
  },
  {
    path: '/eb/acquisti/rda',
    name: 'EB-RDAList',
    component: PurchaseRequestList,
    meta: { title: 'Richieste di Acquisto', requiresAuth: true, module: 'eb' }
  },
  {
    path: '/eb/acquisti/rda/:id',
    name: 'EB-RDADetail',
    component: PurchaseRequestDetail,
    meta: { title: 'Dettaglio RDA', requiresAuth: true, module: 'eb' }
  }
]

// Helpdesk
const HelpdeskView = () => import('../views/Helpdesk/HelpdeskView.vue')

// Settings & Admin
const ActivityLog = () => import('@/core/views/ActivityLog.vue')
const UserList = () => import('@/core/views/Users/UserList.vue')

const settingsRoutes: RouteRecordRaw[] = [
  {
    path: '/eb/activity-log',
    name: 'EB-ActivityLog',
    component: ActivityLog,
    meta: { title: 'Activity Log', requiresAuth: true, module: 'eb' }
  },
  {
    path: '/eb/settings/users',
    name: 'EB-UserList',
    component: UserList,
    meta: { title: 'Gestione Utenti', requiresAuth: true, module: 'eb' }
  },
  {
    path: '/eb/settings',
    name: 'EB-Settings',
    component: () => import('../views/Settings/SettingsUnified.vue'),
    meta: { title: 'Impostazioni', requiresAuth: true, module: 'eb' }
  },
  {
    path: '/eb/settings/backup',
    name: 'EB-BackupView',
    component: () => import('../views/Settings/BackupView.vue'),
    meta: { title: 'Backup & Ripristino', requiresAuth: true, module: 'eb' }
  },
  {
    path: '/eb/settings/vps',
    name: 'EB-VPSView',
    component: () => import('../views/Settings/VPSView.vue'),
    meta: { title: 'Gestione VPS', requiresAuth: true, module: 'eb' }
  },
  {
    path: '/eb/settings/company',
    name: 'EB-CompanyView',
    component: () => import('../views/Settings/CompanyView.vue'),
    meta: { title: 'Gestione Azienda', requiresAuth: true, module: 'eb' }
  },
  {
    path: '/eb/settings/accounting',
    name: 'EB-AccountingSettings',
    component: () => import('../views/Settings/AccountingSettings.vue'),
    meta: { title: 'Impostazioni Contabilità', requiresAuth: true, module: 'eb' }
  },
  {
    path: '/eb/settings/expense-categories',
    name: 'EB-ExpenseCategoriesSettings',
    component: () => import('../views/Settings/ExpenseCategoriesSettings.vue'),
    meta: { title: 'Categorie di spesa', requiresAuth: true, module: 'eb' }
  },
  {
    path: '/eb/reports/situazione-contabile',
    name: 'EB-SituazioneContabile',
    component: () => import('../views/Reports/SituazioneContabile.vue'),
    meta: { title: 'Situazione Contabile', requiresAuth: true, module: 'eb' }
  },
  {
    path: '/eb/settings/billing',
    name: 'EB-BillingSettings',
    component: () => import('../views/Billing/BillingSettings.vue'),
    meta: { title: 'Abbonamento & Fatturazione', requiresAuth: true, module: 'eb' }
  },
  {
    path: '/eb/support/tickets',
    name: 'EB-SupportTickets',
    component: () => import('../views/Support/SupportTicketsList.vue'),
    meta: { title: 'Ticket di Supporto', requiresAuth: true, module: 'eb' }
  }
]

const billingRoutes: RouteRecordRaw[] = [
  {
    path: '/eb/pricing',
    name: 'EB-Pricing',
    component: () => import('../views/Billing/PricingPage.vue'),
    meta: { title: 'Piani e Prezzi', requiresAuth: true, module: 'eb' }
  },
]

// New Department Dashboards
const warehouseDashboardRoutes: RouteRecordRaw[] = [
]

const procurementDashboardRoutes: RouteRecordRaw[] = [
  {
    path: '/eb/procurement/dashboard',
    name: 'EB-ProcurementDashboard',
    component: () => import('../views/Procurement/ProcurementDashboard.vue'),
    meta: { title: 'Dashboard Acquisti', requiresAuth: true, module: 'eb' }
  }
]

const commercialDashboardRoutes: RouteRecordRaw[] = [
  {
    path: '/eb/sales/dashboard',
    name: 'EB-CommercialDashboard',
    component: () => import('../views/Sales/CommercialDashboard.vue'),
    meta: { title: 'Dashboard Commerciale', requiresAuth: true, module: 'eb' }
  }
]

const helpdeskRoutes: RouteRecordRaw[] = [
  {
    path: '/eb/helpdesk',
    name: 'EB-Helpdesk',
    component: HelpdeskView,
    meta: { title: 'Guida Utente', requiresAuth: true, module: 'eb' }
  }
]

const projectRoutes: RouteRecordRaw[] = [
]

const costCenterRoutes: RouteRecordRaw[] = [
  {
    path: '/eb/cost-centers',
    name: 'EB-CostCenterList',
    component: CostCenterList,
    meta: { title: 'Centri di Costo', requiresAuth: true, module: 'eb' }
  },
  {
    path: '/eb/cost-centers/tree',
    name: 'EB-CostCenterTree',
    component: CostCenterTree,
    meta: { title: 'Albero Centri di Costo', requiresAuth: true, module: 'eb' }
  },
  {
    path: '/eb/cost-centers/dashboard',
    name: 'EB-CostCenterDashboard',
    component: CostCenterDashboard,
    meta: { title: 'Dashboard Centri di Costo', requiresAuth: true, module: 'eb' }
  },
  {
    path: '/eb/cost-centers/:id',
    name: 'EB-CostCenterDetail',
    component: CostCenterDetail,
    meta: { title: 'Dettaglio Centro di Costo', requiresAuth: true, module: 'eb' }
  }
]

const electronicInvoiceRoutes: RouteRecordRaw[] = [
]

const ficRoutes: RouteRecordRaw[] = [
  {
    path: '/eb/fic/dashboard',
    name: 'EB-FiCDashboard',
    component: FiCDashboard,
    meta: { title: 'Fatture in Cloud', requiresAuth: true, module: 'eb' }
  },
  {
    path: '/eb/fic/sync-history',
    name: 'EB-FiCSyncHistory',
    component: FiCSyncHistory,
    meta: { title: 'Storico Sync FiC', requiresAuth: true, module: 'eb' }
  }
]

const vatRoutes: RouteRecordRaw[] = [
  {
    path: '/eb/vat/registers',
    name: 'EB-VatRegisters',
    component: VatRegisters,
    meta: { title: 'Registri IVA', requiresAuth: true, module: 'eb' }
  },
  {
    path: '/eb/vat/settlement',
    name: 'EB-VatSettlementNew',
    component: VatSettlement,
    meta: { title: 'Liquidazione IVA', requiresAuth: true, module: 'eb' }
  },
  {
    path: '/eb/vat/settlement-history',
    name: 'EB-VatSettlementHistory',
    component: VatSettlementHistory,
    meta: { title: 'Storico Liquidazioni IVA', requiresAuth: true, module: 'eb' }
  },
]

export const ebRoutes: RouteRecordRaw[] = [
  ...dashboardRoutes,
  ...customerRoutes,
  ...boilerRoutes,
  ...interventionRoutes,
  ...settingsRoutes,
  ...templateRoutes,
  ...crmRoutes,
  ...callLogRoutes,
  ...taskRoutes,
  ...salesRoutes,
  ...warehouseRoutes,
  ...manualsRoutes,
  ...catalogRoutes,
  ...accountingRoutes,
  ...legacyPurchaseRoutes,
  ...stockRoutes,
  ...reportRoutes,
  ...supplierRoutes,
  ...purchaseRoutes,
  ...expirationRoutes,
  ...certificationRoutes,
  ...contoTermicoRoutes,
  ...employeeRoutes,
  ...expenseRoutes,
  ...directPurchaseRoutes,
  ...gdprRoutes,
  ...procurementRoutes,
  ...warehouseDashboardRoutes,
  ...procurementDashboardRoutes,
  ...commercialDashboardRoutes,
  ...helpdeskRoutes,
  ...projectRoutes,
  ...costCenterRoutes,
  ...electronicInvoiceRoutes,
  ...ficRoutes,
  ...vatRoutes,
  ...billingRoutes
]

export default ebRoutes
